import moment from 'moment';

/** weekday 1–7 (Sunday–Saturday); each row expands to concrete slots between rangeStart and rangeEnd (inclusive days). */
export function expandCeremonyTimes(ceremonyTimes, rangeStart, rangeEnd, titleLabel, descriptionLabel) {
  if (!ceremonyTimes?.length || !rangeStart || !rangeEnd) return [];

  const out = [];
  const startM = moment(rangeStart).startOf('day');
  const endM = moment(rangeEnd).startOf('day');

  for (let d = startM.clone(); d.isSameOrBefore(endM); d.add(1, 'day')) {
    const wd = d.day();
    ceremonyTimes.forEach((ct, idx) => {
      if (Number(ct.weekday) !== wd + 1) return;

      const dateStr = d.format('YYYY-MM-DD');
      let ts = ct.start_time || '';
      if (ts.length === 5) ts = `${ts}:00`;

      const startDt = moment(`${dateStr}T${ts}`).toDate();
      let endDt;
      let recurringFinish = ct.finish_time || null;

      if (ct.finish_time) {
        let tf = ct.finish_time;
        if (tf.length === 5) tf = `${tf}:00`;
        endDt = moment(`${dateStr}T${tf}`).toDate();
      } else {
        endDt = moment(startDt).add(1, 'hour').toDate();
        recurringFinish = null;
      }

      out.push({
        id: `ceremony-${ct.weekday}-${ts}-${idx}-${dateStr}`,
        title: titleLabel,
        description: descriptionLabel,
        going: null,
        allDay: false,
        isRecurring: true,
        recurringFinish,
        start: startDt,
        end: endDt,
      });
    });
  }

  return out;
}
